import styles from "./Gallery.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import gallery_icon from "../../assets/images/icons/gallery_ace.svg";

import "../../fonts/Futura-PT-Book.ttf";
const Gallery = () => {
  return (
    <>
      <Header />
      <div className={`${styles.gallery_container_main}`}>
        <div className={`${styles.gallery_header_div}`}>
          <img
            className={`${styles.gallery_header_div_image}`}
            style={{ height: "25px", width: "31px" }}
            alt="gallery icon"
            src={gallery_icon}
          />
          <div className={`${styles.gallery_header_div_text}`}>Gallery</div>
        </div>

        <div className={`${styles.gallery_information_div}`}>
          <div className={styles.information_icon_div}>
            <ion-icon
              className={styles.information_icon}
              name="information-circle"
            ></ion-icon>
            <div className={styles.information_icon_text}>お知らせ</div>
          </div>
          <div className={styles.info_section}>
            <div className={styles.info_row}>
              <svg width="11" height="11">
                <circle cx="5.5" cy="5.5" r="5.5" fill="#4B4B4B" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Gallery;
